"use strict";

import $ from "jquery";

const defaultSelectors = {
    base: '.js-nav',
    item: '.js-nav__item'
};

export function createInitInScope(selectors = defaultSelectors) {

    if(matchMedia('(max-width: 1199px)').matches){
        /* not on mobile */
        return;
    }

    return function ($scope) {
        return $scope.find(selectors.base).each(function () {
            let $nav = $(this);
            let $navItems = $nav.find(selectors.item);
            let $navItemsLinks = $($navItems.children());

            $navItemsLinks.on('touchend', function (evt) {
                if (globalThis.TouchEvent && evt.originalEvent instanceof globalThis.TouchEvent) {
                    if (!$(this).closest(defaultSelectors.item).hasClass('is-open')) {
                        $(this).closest(defaultSelectors.base).find('li').removeClass('is-open');
                        $(this).closest(defaultSelectors.item).addClass('is-open');

                        evt.preventDefault();
                        evt.stopImmediatePropagation();

                        $('body').on('click', bodyClickHandler);
                    }
                }
            });
        });
    }
}

function bodyClickHandler (evt) {
    if ($(evt.target).parents(defaultSelectors.base).length < 1) {
        evt.preventDefault();
        $(defaultSelectors.item).removeClass('is-open');
        $('body').off('click', bodyClickHandler);
    }
}

export const initInScope = createInitInScope();
